import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("titan_token", data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-100 flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="noise-overlay" />
      <div className="w-full max-w-md bg-white border border-zinc-300 shadow-[8px_8px_0px_0px_#09090B] p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src="/logo192.png" alt="Anchor Moving logo" className="w-10 h-10 object-cover" />
          <div>
            <p className="font-display uppercase text-xl leading-none">Anchor Moving</p>
            <p className="font-sub text-xs tracking-[0.2em] uppercase text-zinc-500">Crew Access</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="font-sub text-xs tracking-[0.2em] uppercase text-zinc-500 block mb-2">Email</label>
            <input
              data-testid="admin-login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-zinc-300 rounded-none px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0057FF] focus:ring-offset-0"
              placeholder="615.anchormoving@gmail.com"
            />
          </div>
          <div>
            <label className="font-sub text-xs tracking-[0.2em] uppercase text-zinc-500 block mb-2">Password</label>
            <input
              data-testid="admin-login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-zinc-300 rounded-none px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#0057FF] focus:ring-offset-0"
              placeholder="••••••••"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" className="text-sm font-semibold text-red-600 border border-red-300 bg-red-50 px-3 py-2">
              {error}
            </p>
          )}
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="w-full bg-[#0057FF] text-white font-sub font-bold uppercase tracking-[0.15em] text-sm py-4 rounded-none shadow-[4px_4px_0px_0px_#09090B] transition-[transform,box-shadow] duration-150 hover:-translate-x-0.5 hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_#09090B] disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <Link
          data-testid="admin-login-back-link"
          to="/"
          className="mt-6 inline-flex items-center gap-2 text-xs font-sub uppercase tracking-[0.2em] text-zinc-500 hover:text-[#0057FF] transition-colors"
        >
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
      </div>
    </div>
  );
}
